<template>
    <ModalComponent
        name="exportar-codigos"
        title="Exportación de códigos"
        @close="() => close(false)"
    >
        <b-row class="text-center">
            <b-col cols="12" class="mb-3">
                <h3>Se está procesando la generación del fichero. Recibirá una notificación cuando esté listo.</h3>
            </b-col>
        </b-row>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        methods: {
            close() {
                this.$emit('close', 'exportar-codigos');
            }
        },
        components: {
            ModalComponent
        }
    }
</script>
